/**
 * Application configuration
 * Loads environment variables and provides typed configuration
 */

export const config = {
  // API Configuration
  api: {
    url: import.meta.env.VITE_API_URL || 'http://localhost:3000/api',
    timeout: Number(import.meta.env.VITE_API_TIMEOUT) || 30000,
  },

  // App Configuration
  app: {
    name: import.meta.env.VITE_APP_NAME || 'E-Inventory',
    url: import.meta.env.VITE_APP_URL || 'http://localhost:5173',
    env: import.meta.env.VITE_APP_ENV || 'development',
  },

  // Session Configuration
  session: {
    timeout: Number(import.meta.env.VITE_SESSION_TIMEOUT) || 3600000, // 1 hour
    refreshThreshold: Number(import.meta.env.VITE_SESSION_REFRESH_THRESHOLD) || 300000, // 5 minutes
  },

  // Cookie Configuration
  cookie: {
    domain: import.meta.env.VITE_COOKIE_DOMAIN || undefined, // Let browser handle domain
    secure: import.meta.env.VITE_COOKIE_SECURE === 'true' || window.location.protocol === 'https:',
    sameSite: (import.meta.env.VITE_COOKIE_SAME_SITE || 'lax') as 'strict' | 'lax' | 'none',
  },

  // Feature Flags
  features: {
    analytics: import.meta.env.VITE_ENABLE_ANALYTICS === 'true',
    debug: import.meta.env.VITE_ENABLE_DEBUG === 'true',
    mockApi: import.meta.env.VITE_ENABLE_MOCK_API === 'true',
  },

  // Storage Configuration
  storage: {
    prefix: import.meta.env.VITE_STORAGE_PREFIX || 'e_inventory_',
    version: import.meta.env.VITE_STORAGE_VERSION || '1.0.0',
  },

  // Environment checks
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,
} as const;

// Type-safe environment variable access
export type Config = typeof config;

// Export individual configs for convenience
export const { api, app, session, cookie, features, storage, isDevelopment, isProduction } = config;
